import React from "react"

function VariantSelector({
  name,
  values,
  index,
  checkDisabled,
  handleOptionChange,
  selectedOption,
  mobile,
}) {
  return mobile ? (
    <div className="product__selector--mobile">
      <h4 className="p">SELECT {name}</h4>
      <select onBlur={e => handleOptionChange(index, e)}>
        {values.map(v => (
          <option value={v} key={`${name}-${v}`}>
            {v.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  ) : (
    <div className="product__selector">
      <h4 className="h2">{name}:</h4>
      <div>
        {values.map(v => (
          <button
            className={`h2 ${v === selectedOption ? "active" : ""}`}
            value={v}
            key={`${name}-${v}`}
            disabled={checkDisabled(name, v)}
            onClick={e => handleOptionChange(index, e)}
          >
            {v}
          </button>
        ))}
      </div>
    </div>
  )
}

export default VariantSelector
